import { render, staticRenderFns } from "./valTypeForPer.vue?vue&type=template&id=68f77d79&scoped=true"
import script from "./valTypeForPer.vue?vue&type=script&lang=js"
export * from "./valTypeForPer.vue?vue&type=script&lang=js"
import style0 from "./valTypeForPer.vue?vue&type=style&index=0&id=68f77d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f77d79",
  null
  
)

export default component.exports